import { call, put, takeEvery } from 'redux-saga/effects';
// import Api from './'

// Crypto Redux States
import { dashboardPWTypes } from './actionTypes';
import {
  getFilterListSuccessPW,
  getFilterListFailPW,
  getFilterDataSuccessPW,
  getFilterDataFailPW,
} from './actions';

//Include Both Helper File with needed methods
import {
  getFilterListPW,
  getFilterDataPW,
} from '../../helpers/dasboard_helperPW';

function* fetchFilterlistPW() {
  try {
    const response: Promise<any> = yield call(getFilterListPW);
    yield put(getFilterListSuccessPW(response));
  } catch (error) {
    yield put(getFilterListFailPW(error));
  }
}

function* fetchFilterDataPW(data: any) {
  try {
    const response: Promise<any> = yield call(getFilterDataPW, data.payload);
    yield put(getFilterDataSuccessPW(response));
  } catch (error) {
    yield put(getFilterDataFailPW(error));
  }
}

function* dashboardPWSaga() {
  yield takeEvery(dashboardPWTypes.GET_FILTER_LISTPW, fetchFilterlistPW);
  yield takeEvery(dashboardPWTypes.GET_FILTER_DATAPW, fetchFilterDataPW);
}

export default dashboardPWSaga;
